import * as React from 'react';

export interface PageProps {
  className?: string;
  children: React.ReactNode;
}

export function Page({ className, children }: PageProps) {
  return <div className={['page', className].filter(Boolean).join(' ')}>{children}</div>;
}

export interface PageSectionProps {
  className?: string;
  children: React.ReactNode;
}

export function PageSection({ className, children }: PageSectionProps) {
  return <section className={['page__section', className].filter(Boolean).join(' ')}>{children}</section>;
}
